var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconDownloadBlue = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14.142,
  height: 14.79,
  viewBox: "0 0 14.142 14.79",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1235",
  "data-name": "Group 1235",
  transform: "translate(-518.913 -445.333)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1124",
  "data-name": "Group 1124",
  transform: "translate(518.913 445.333)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_85",
  "data-name": "Ellipse 85",
  transform: "translate(0.051)",
  fill: "none",
  stroke: "#173a6d",
  strokeWidth: 0.7
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.818,
  cy: 7.395,
  rx: 6.818,
  ry: 7.395,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.818,
  cy: 7.395,
  rx: 6.468,
  ry: 7.045,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "_24px_1_",
  "data-name": "24px (1)",
  transform: "translate(0 0.28)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2460",
  "data-name": "Path 2460",
  d: "M0,0H14.142V14.23H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1133",
  "data-name": "Group 1133",
  transform: "translate(10.429 4.768) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M1.4,6.43H.192C.086,6.43,0,6.372,0,6.3V.131C0,.059.086,0,.192,0H1.4",
  transform: "translate(4.82 6.43) rotate(180)",
  fill: "none",
  stroke: "#173a6d",
  strokeMiterlimit: 10,
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M0,0",
  transform: "translate(3.6 3.704)",
  fill: "none",
  stroke: "#173a6d",
  strokeMiterlimit: 10,
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_249",
  "data-name": "Group 249",
  transform: "translate(0 1.783)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_58",
  "data-name": "Line 58",
  x1: 3.494,
  transform: "translate(0 1.433)",
  fill: "none",
  stroke: "#173a6d",
  strokeMiterlimit: 10,
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M0,2.865l1.209-1.4a.058.058,0,0,0,0-.07L0,0",
  transform: "translate(2.255)",
  fill: "none",
  stroke: "#173a6d",
  strokeMiterlimit: 10,
  strokeWidth: 0.7
}))))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDownloadBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_download_blue.0041ee89.svg";
export { ForwardRef as ReactComponent };